import { about } from '../../portfolio'
import profilePhoto400 from '../../images/zac_profile_img_400.jpg'
import profilePhoto800 from '../../images/zac_profile_img_800.jpg'
import './About.css'

const About = () => {
  const { name, role, description } = about

  return (
    <div className='about center'>
      <div className='about_name__container'>
        {name && (
          <h1>
            Hi, I&apos;m <span className='about__name'>{name}.</span>
          </h1>
        )}
      </div>

      <img
        className='responsive-img'
        src={profilePhoto400}
        srcSet={`${profilePhoto400} 400w, ${profilePhoto800} 800w`}
        sizes='(max-width: 600px) 85vw, 400px'
        alt='profile'
        width='400'
        height='400'
        loading='eager'
        decoding='async'
        fetchpriority='high'
      />

      {role && <h2 className='about__role'>A {role}.</h2>}
      <p className='about__desc'>{description && description}</p>
    </div>
  )
}

export default About
